export interface iProvincia {
  Id: number,
  Nombre: string
}

export const provincias: iProvincia[] = [
    {
      "Id": 1,
      "Nombre": "ALAVA"
    },
    {
      "Id": 2,
      "Nombre": "ALBACETE"
    },
    {
      "Id": 3,
      "Nombre": "ALICANTE"
    },
    {
      "Id": 4,
      "Nombre": "ALMERIA"
    },
    {
      "Id": 5,
      "Nombre": "AVILA"
    },
    {
      "Id": 6,
      "Nombre": "BADAJOZ"
    },
    {
      "Id": 7,
      "Nombre": "BALEARES"
    },
    {
      "Id": 8,
      "Nombre": "BARCELONA"
    },
    {
      "Id": 9,
      "Nombre": "BURGOS"
    },
    {
      "Id": 10,
      "Nombre": "CACERES"
    },
    {
      "Id": 11,
      "Nombre": "CADIZ"
    },
    {
      "Id": 12,
      "Nombre": "CASTELLON"
    },
    {
      "Id": 13,
      "Nombre": "CIUDAD REAL"
    },
    {
      "Id": 14,
      "Nombre": "CORDOBA"
    },
    {
      "Id": 15,
      "Nombre": "LA CORUÑA"
    },
    {
      "Id": 16,
      "Nombre": "CUENCA"
    },
    {
      "Id": 17,
      "Nombre": "GIRONA"
    },
    {
      "Id": 18,
      "Nombre": "GRANADA"
    },
    {
      "Id": 19,
      "Nombre": "GUADALAJARA"
    },
    {
      "Id": 20,
      "Nombre": "GUIPUZCOA"
    },
    {
      "Id": 21,
      "Nombre": "HUELVA"
    },
    {
      "Id": 22,
      "Nombre": "HUESCA"
    },
    {
      "Id": 23,
      "Nombre": "JAEN"
    },
    {
      "Id": 24,
      "Nombre": "LEON"
    },
    {
      "Id": 25,
      "Nombre": "LLEIDA"
    },
    {
      "Id": 26,
      "Nombre": "LA RIOJA"
    },
    {
      "Id": 27,
      "Nombre": "LUGO"
    },
    {
      "Id": 28,
      "Nombre": "MADRID"
    },
    {
      "Id": 29,
      "Nombre": "MALAGA"
    },
    {
      "Id": 30,
      "Nombre": "MURCIA"
    },
    {
      "Id": 31,
      "Nombre": "NAVARRA"
    },
    {
      "Id": 32,
      "Nombre": "ORENSE"
    },
    {
      "Id": 33,
      "Nombre": "ASTURIAS"
    },
    {
      "Id": 34,
      "Nombre": "PALENCIA"
    },

    {
      "Id": 35,
      "Nombre": "LAS PALMAS"
    },

    {
      "Id": 36,
      "Nombre": "PONTEVEDRA"
    },

    {
      "Id": 37,
      "Nombre": "SALAMANCA"
    },

    {
      "Id": 38,
      "Nombre": "TENERIFE"
    },
    {
      "Id": 39,
      "Nombre": "CANTABRIA"
    },

    {
      "Id": 40,
      "Nombre": "SEGOVIA"
    },

    {
      "Id": 41,
      "Nombre": "SEVILLA"
    },

    {
      "Id": 42,
      "Nombre": "SORIA"
    },

    {
      "Id": 43,
      "Nombre": "TARRAGONA"
    },

    {
      "Id": 44,
      "Nombre": "TERUEL"
    },

    {
      "Id": 45,
      "Nombre": "TOLEDO"
    },
    {
      "Id": 46,
      "Nombre": "VALENCIA"
    },

    {
      "Id": 47,
      "Nombre": "VALLADOLID"
    },

    {
      "Id": 48,
      "Nombre": "VIZCAYA"
    },

    {
      "Id": 49,
      "Nombre": "ZAMORA"
    },

    {
      "Id": 50,
      "Nombre": "ZARAGOZA"
    },

    {
      "Id": 51,
      "Nombre": "CEUTA"
    },
    {
      "Id": 52,
      "Nombre": "MELILLA"
    },
    {
      "Id": 71,
      "Nombre": "ANDALUCIA"
    },
    {
      "Id": 72,
      "Nombre": "ARAGON"
    },

    {
      "Id": 75,
      "Nombre": "CANARIAS"
    },

    {
      "Id": 77,
      "Nombre": "CASTILLA LA MANCHA"
    },

    {
      "Id": 78,
      "Nombre": "CASTILLA Y LEÓN"
    },

    {
      "Id": 79,
      "Nombre": "CATALUÑA"
    },

    {
      "Id": 80,
      "Nombre": "COMUNIDAD VALENCIANA"
    },

    {
      "Id": 81,
      "Nombre": "EXTREMADURA"
    },
    {
      "Id": 82,
      "Nombre": "GALICIA"
    },
    {
      "Id": 86,
      "Nombre": "PAÍS VASCO"
    },
    {
      "Id": 99,
      "Nombre": "ESTATAL"
    }
  ];
